export const RatingType = {
	writingQuality: 2,
	imageIllustrationQuality: 3,
	characterDevelopment: 4,
	couldntPutItDownness: 5,
	intellectualDepth: 6,
	originality: 7,
	overall: 9,
	none: -1,
};
